import React from 'react';
import { Title, Button, Text } from 'ui';
import logo from '../assets/logo-white.png'

export default function InviteNotFound(props) {
  return (
    <div className="auth auth-login">
      <div className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">Invitation not found.</Title>
        <div style={{paddingBottom:16}}>
          <Text white>
            Your invitation was not found. Please contact your company admin to 
            issue a new invitation.
          </Text>
        </div>
        <div style={{paddingBottom:16}}>
          <Text white>
            To create a new company, <Button orange tertiary to="register">register here.</Button>
          </Text>
        </div>
      </div>
    </div>
  );
}